// =============================================================================
// Apotheca Waitlist Client
// =============================================================================
//
// Handles the "Notify me when available" waitlist form on Coming Soon PDPs.
// Submits to Supabase edge function via Shopify App Proxy at
// /apps/gabriel/product-waitlist — the proxy HMAC-signs the request so only
// Shopify-originated traffic is accepted server-side.
//
// Exposed: window.ApothecaWaitlist.submit(event)
//
// =============================================================================
(function () {
  'use strict';

  const ENDPOINT = 'https://dvvcdxxtfyonrqlijfyb.supabase.co/functions/v1/product-waitlist';

  function showError(form, message) {
    const errEl = form.querySelector('.waitlist-error');
    if (errEl) {
      errEl.textContent = message;
      errEl.style.display = 'block';
    }
    const successEl = form.querySelector('.waitlist-success');
    if (successEl) successEl.style.display = 'none';
  }

  function showSuccess(form, already) {
    const successEl = form.querySelector('.waitlist-success');
    if (successEl) {
      const span = successEl.querySelector('span');
      if (span) {
        span.textContent = already
          ? "You're already on the list. We'll email you when this product is available."
          : "You're on the list. We'll email you when this product is available.";
      }
      successEl.style.display = 'flex';
    }
    const errEl = form.querySelector('.waitlist-error');
    if (errEl) errEl.style.display = 'none';
    // Hide the input + button after success
    const field = form.querySelector('.waitlist-field');
    if (field) field.style.display = 'none';
  }

  async function submit(event) {
    event.preventDefault();
    const form = event.currentTarget || event.target;
    const emailInput = form.querySelector('input[name="email"]');
    const btn = form.querySelector('.waitlist-btn');
    const btnText = form.querySelector('.waitlist-btn-text');

    if (!emailInput || !emailInput.value.trim()) {
      showError(form, 'Please enter a valid email address.');
      return false;
    }

    // UI: disable button, show loading state
    const originalText = btnText ? btnText.textContent : 'Notify Me';
    if (btn) btn.disabled = true;
    if (btnText) btnText.textContent = 'Adding…';

    try {
      const response = await fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: emailInput.value.trim(),
          product_handle: form.dataset.productHandle,
          product_id: form.dataset.productId,
          product_title: form.dataset.productTitle,
          source: 'pdp_waitlist',
        }),
      });

      if (!response.ok) {
        let msg = 'Something went wrong. Please try again.';
        try {
          const j = await response.json();
          if (j.error) msg = j.error;
        } catch (_) {}
        showError(form, msg);
        if (btn) btn.disabled = false;
        if (btnText) btnText.textContent = originalText;
        return false;
      }

      const data = await response.json();
      showSuccess(form, !!data.already_signed_up);

      // Fire dataLayer / GA event if analytics is wired
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'waitlist_joined',
          product_handle: form.dataset.productHandle,
          already_signed_up: !!data.already_signed_up,
        });
      }
    } catch (e) {
      showError(form, 'Network error. Please check your connection and try again.');
      if (btn) btn.disabled = false;
      if (btnText) btnText.textContent = originalText;
    }

    return false;
  }

  window.ApothecaWaitlist = { submit };
})();
